module.exports = __webpack_public_path__ + "img/296806.bc22d350.jpg";